import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { MarketplacePageComponent } from '../../marketplace/marketplace.component';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import {
  BehaviorSubject,
  debounceTime,
  fromEvent,
  Subject,
  Subscription,
  switchMap,
  takeUntil,
} from 'rxjs';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { CompareProductListComponent } from '../../compare-product-list/compare-product-list.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { RecommendationsFormComponent } from '../recommandations-form/recommandations-form.component';
import { REGION_CATEGORY_IMAGE_LIST } from '../../marketplace/marketplace.model';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: [
    '../../marketplace/marketplace.component.scss',
    './search.component.scss',
  ],
})
export class SearchComponent implements OnInit, OnDestroy {
  //////////////////// core related to region select /////////////////////
  public regionCategoryImageList: Array<any> = REGION_CATEGORY_IMAGE_LIST;
  public selectedRegionForCategoryPopup = null;
  carouselOptionsList: any = {
    spaceBetween: 10,
    slidesPerView: 'auto',
    grid: {
      rows: 2,
      fill: 'row',
    },

    // pagination: false,
  };
  carouselWithNavOptions2: any = {
    spaceBetween: 8,
    slidesPerView: 'auto',
    // loop: true,
    pagination: false,
    grid: {
      rows: 2,
      fill: 'row',
    },
  };
  handleError(event: any): void {
    (event.target as HTMLImageElement).src =
      '../../../../assets/images/shop/default.png';
  }
  public filteredSubRegions = [];

  @ViewChild('selectRegions')
  public selectRegions: TemplateRef<any>;
  public openSelectRegions() {
    this.modalService.open(this.selectRegions, { size: 'md' });
  }

  public currentFilteredSubregions = []; //this is based on bottomSubregions

  public setCurrentRegion(region) {
    this.currentFilteredSubregions = this.bottomSubregions
      .filter((sub) => sub.regionName == region.name)
      .map((sub) => {
        return { ...sub, checked: false };
      });
    this.cdr.detectChanges();
  }
  public goToSubRegion(subRegionSlug) {
    this.modalService.dismissAll();
    this.router.navigateByUrl(
      `/category/${this.subCategory?.slug}/${subRegionSlug}`
    );
    // this.getProductList(this.currentFilteredSubregions.filter(sub => sub.checked).map(sub => sub.subRegionId), true);
  }
  public baseUrl: string = '../../../../../assets/images/shop/';
  ////////////////////////////////////////////////////////////
  private destroy$ = new Subject<void>();
  @ViewChild('marketplace') marketplacePage: MarketplacePageComponent;

  public subCategory: any = {
    relationCategories: [],
  };
  public subCategoryList: Array<any> = [];
  public totalMemberShopProductList: Array<any> = [];
  public currentCategorySlug: string = '';
  public currentCategoryName: string = '';
  public parentCategory: any = {};
  public currentCategoryBG: string = '';
  public imgUrl = environment.ImageUrl;
  public isLogin: boolean = false;
  public isLoading = false;

  private routeSubscription: Subscription | null = null;

  constructor(
    private _location: Location,
    private route: ActivatedRoute,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private customerService: CustomerService,
    private toastr: ToastrService,
    private seoService: SeoService,
    private sharedService: SharedService,
    private router: Router,
    //private store: Store<AppState>,
    private roleService: RoleService,
    private modalService: NgbModal,
    private commonService: CommonService,
    private cdr: ChangeDetectorRef,
    private bottomSheet: MatBottomSheet
  ) {}
  ngOnDestroy(): void {
    // console.log("[Start Destroy] Search Component")
    this.local.clearTimeout(this.timeout1);
    this.local.clearTimeout(this.timeout2);
    this.routeSubscription?.unsubscribe();
    this._fetchProductsSubscription?.unsubscribe();

    this._roleSubscription?.unsubscribe();
    this._userDetailsSubscription?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
    // console.log("[End Destroy] Search Component")
  }

  public topImageLoad(event) {
    event.target.classList.remove('d-none'); //show the img if there are no errors only
  }

  public productSelectedChanged(product, isSelected) {
    let indexOfProduct = this.productsToCompare.indexOf(product);
    if (isSelected) {
      if (indexOfProduct == -1) {
        this.productsToCompare.push(product);
      }
    } else {
      if (indexOfProduct !== -1) {
        this.productsToCompare.splice(indexOfProduct, 1);
      }
    }
    if (this.productsToCompare.length >= 6) {
      this.toastr.info('Can only compare 5 products max');
      this.productsToCompare.pop();
    }
  }

  public lastPage;
  private _fetchProductsSubscription: Subscription | null = null;
  public productsToCompare = [];
  public isSubregionCombination = false;

  private _userDetailsSubscription: Subscription | null = null;
  private _roleSubscription: Subscription | null = null;
  private _getUserLoginInfo() {
    this._userDetailsSubscription = this.local
      .getUserDetailsObserver()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        this.isLogin = user?.id ? true : false;
        this.cdr.detectChanges();
      });
    this._roleSubscription = this.roleService.rolesSubject.subscribe(() => {
      this.isUserAnAdmin = this.roleService?.roles?.userType.includes('ADMIN');
      this.cdr.detectChanges();
    });
  }

  public breadcrumbs = [];
  public currentTypeName: string = '';
  public breadCrumbData = null;
  public isTypeInfoLoaded = false;
  public currentType = null;
  public isOnBrowser = false;
  public timeout1: any;

  private savedScrollPosX = null;
  private savedScrollPosY = null;

  public goToPage(url) {
    this.savedScrollPosX = window.scrollX || window.pageXOffset;
    this.savedScrollPosY = window.scrollY || window.pageYOffset;
    this.router.navigateByUrl(url);
  }

  ngOnInit(): void {
    if (this.sharedService.isBrowser()) {
      this.isOnBrowser = true;
    }
    this._fetchSubRegions();
    this._getUserLoginInfo();
    this.fetchProductRegionCounts();

    this.routeSubscription?.unsubscribe();

    this.routeSubscription = this.route.paramMap
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        //queryParams
        // console.log('params changed')
        this.totalMemberShopProductList = [];
        this.currentTypeName = '';
        this.currentPage = 1;
        this.lastPage = -1;
        // console.log({ params })
        if (params.get('subregionName')) {
          this.currentSubRegionName = params.get('subregionName');
          this.subRegionSlug = params.get('subregionSlug');
        }
        if (params.get('categoryName')) {
          this.currentCategorySlug = params.get('categoryName');
          this.currentCategoryName = '';
          this.getCategoryRelationship(
            params.get('categoryName'),
            params.get('subCategoryName')
              ? params.get('subCategoryName').trim()
              : ''
          );
        }

        if (params.get('subCategoryName')) {
          this.currentTypeName = params.get('subCategoryName');
          this.auth
            .getSubCategoryTypeInfo(this.currentTypeName)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (data: any) => {
                this.currentTypeName = data?.data?.name;
                this.isTypeInfoLoaded = true;
                this.currentType = data?.data;
                this.seoService.update({
                  title: this.seoTitle,
                  description: this.bottomText,
                  main_title: ' | BEST SERVICES SG',
                });
                this.cdr.detectChanges();
              },
              error: console.error,
            });
        }

        if (params.get('slug')) {
          const param: string = params.get('slug');
          //console.log({slug: param})
          if (/^[A-Za-z\-,]+$/.test(param)) {
            //no number or other character except '-' to check if category slug
            this.currentSubRegionName = param
              .split('-')
              .join(' ')
              .toLowerCase()
              .split(' ')
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ');

            this.subRegionSlug = param;
            this.isSubregionCombination = true;
            this.cdr.detectChanges();
            return;
          }

          this.local.clearTimeout(this.timeout1);
          this.timeout1 = setTimeout(() => {
            this.viewProductDetails({ id: params.get('slug').split('-')[1] });
          }, 1000);
        }
        this._setBreadCrumb();
        setTimeout(() => {
          if (this.sharedService.isBrowser()) {
            window.scrollTo(
              this.savedScrollPosX ?? 0,
              this.savedScrollPosY ?? 0
            );
          }
        });
      });
    this._setBreadCrumb();
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  private get seoTitle(): string {
    return `${this.currentSubRegionName ? 'Best' : ''} ${
      this.currentType?.name &&
      this.currentType?.name != 'undefined' &&
      this.currentType?.name != 'null'
        ? this.currentType?.name
        : ''
    } ${this.subCategory?.name} ${
      this.currentSubRegionName ? 'in ' + this.currentSubRegionName : ''
    } | BEST SERVICES SG`;
  }
  public stopScroll(event) {
    event.stopPropagation();
  }

  public get isMainCategory(): boolean {
    return (
      this.parentCategory == null ||
      this.parentCategory?.id == this.subCategory?.id ||
      !this.parentCategory?.id
    );
  }

  timeout2: any;

  private _setBreadCrumb() {
    this.local.clearTimeout(this.timeout2);
    this.timeout2 = setTimeout(() => {
      this.breadCrumbData = [
        this.parentCategory?.name &&
        this.parentCategory?.name != this.currentCategoryName
          ? {
              name: this.parentCategory.name,
              link: '/category/' + this.parentCategory.slug,
              active: false,
            }
          : {},
        {
          name: this.currentCategoryName,
          link: '/category/' + this.currentCategorySlug,
          active: this.currentSubRegionName ? false : true,
        },
        this.currentTypeName
          ? {
              name: this.currentTypeName,
              link:
                '/category/' +
                this.currentCategorySlug +
                '/region/' +
                this.subRegionSlug,
              active: true,
            }
          : {},
        this.currentSubRegionName
          ? {
              name: this.currentSubRegionName,
              link: '/region/' + this.subRegionSlug,
              active: this.currentSubRegionName ? true : false,
            }
          : {},
      ];
    }, 500);

    this.cdr.detectChanges();
  }
  public regionCounts = {};

  public postalCode: any = {};
  async handlePostalCodeChange(event: any) {
    const postalCode = event.target.value?.trim();
    if (postalCode && postalCode.length === 6) {
      const latLong = await this.local.getLatLongByPostalCode(postalCode);
      this.postalCode =
        typeof latLong === 'string' ? JSON.parse(latLong) : latLong;
    } else {
      this.postalCode = {};
    }

    // this.currentFilteredSubregions = this.bottomSubregions.filter(sub => sub.postalCode?.includes(postalCode.substring(0, 2))).map(sub => {
    //   return { ...sub, checked: false }
    // })
    // console.log('filtering regions to', this.filteredSubRegions, postalCode.substring(2))
    this.cdr.detectChanges();
  }
  private async fetchProductRegionCounts() {
    this.auth
      .getSubRegionProductCounts()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (results: any) => {
          this.regionCounts = results.body;
          this.cdr.detectChanges();
        },
        error: console.error,
      });
  }
  public sunRegionButtonClicked($event, r) {
    // console.log($event, r)
    //r.checked!! != r.checked;
    this.goToSubRegion(r.slug);
    // console.log({ r })
  }
  /***************************  Code related to subregions on  the bottom side **************************/
  public currentSubRegionName: string = '';
  public subRegionSlug: string = '';
  public bottomSubregions = [];
  private _fetchSubRegions() {
    this.auth
      .getMemberShopSubRegion()
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp: ApiResponse) => {
        this.bottomSubregions = resp.body.map((sub) => {
          return { ...sub, checked: false };
        });
        this.cdr.detectChanges();
      });
  }
  public setRegion(subregion) {
    this.subRegionSlug = subregion?.slug;
    this.router.navigateByUrl(
      `category/${this.subCategory.slug}/${(subregion?.slug)
        .split(' ')
        .join('-')}`
    );
  }

  /************************* Code related to editing category ******************************/
  @ViewChild('editCategory')
  public editCategoryModal: ElementRef;
  public categoryEditMode = '';

  openEditCategoryModal() {
    if (this.isSubregionCombination) {
      this._getCombinationInfos();
    }
    this.categoryEditMode = this.subRegionSlug;
    this.categoryName = this.subCategory?.name;

    try {
      this.subCategory.faqInfos = JSON.parse(this.subCategory.faqInfos);
    } catch (e) {
      console.error(e);
    }
    this.currentBottomText = this.bottomText;

    if (!this.isSubregionCombination) {
      this.questionFive = this.subCategory?.faqInfos?.questionFive;
      this.questionFour = this.subCategory?.faqInfos?.questionFour;
      this.questionThree = this.subCategory?.faqInfos?.questionThree;
      this.questionTwo = this.subCategory?.faqInfos?.questionTwo;
      this.questionOne = this.subCategory?.faqInfos?.questionOne;

      this.answerOne = this.subCategory?.faqInfos?.answerOne;
      this.anserFive = this.subCategory?.faqInfos?.anserFive;
      this.anserFour = this.subCategory?.faqInfos?.anserFour;
      this.anserThree = this.subCategory?.faqInfos?.anserThree;
      this.answerTwo = this.subCategory?.faqInfos?.answerTwo;
      this.categoryMeta = this.subCategory?.categoryMeta; //invalid json everytime!
      this.codeSchema = this.subCategory?.codeSchema;
      this.categoryImage = this.subCategory?.categoryImage;
    }

    try {
      this.domMeta = Array.from(document.querySelectorAll('meta'))
        .map((meta) => {
          return `<meta name ='${
            meta.getAttribute('name') || null
          }'  property='${meta.getAttribute('property') || null}' 
        content='${meta.getAttribute('content') || null}'
        >`;
        })
        .join('\n');
      this.domSchema = Array.from(
        document.querySelectorAll('script[type="application/ld+json"]')
      )
        .map((elem) => {
          return `<script type="application/ld+json">
             ${elem.textContent}
        </script>`;
        })
        .join('\n');
    } catch (e) {
      console.error(e);
      this.toastr.error(
        'Something went wrong while fetching schema and meta from DOM'
      );
    }

    this.modalService
      .open(this.editCategoryModal, { size: 'md' })
      .dismissed.pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this._getCombinationInfos();
      });
  }

  categoryEditModeChange(event) {
    this.categoryEditMode = event.target.value;
    this._getCombinationInfos(this.categoryEditMode);
  }

  paginateRegion(isNext: boolean) {
    if (isNext) {
      const region =
        this.bottomSubregions[
          this.bottomSubregions.findIndex(
            (s) => s.slug === this.categoryEditMode
          ) + 1
        ];
      if (region) {
        this.categoryEditMode = region.slug;
      }
    } else {
      const region =
        this.bottomSubregions[
          this.bottomSubregions.findIndex(
            (s) => s.slug === this.categoryEditMode
          ) - 1
        ];
      if (region) {
        this.categoryEditMode = region.slug;
      }
    }
    this._getCombinationInfos(this.categoryEditMode);
  }

  public imageBase64: string | ArrayBuffer;
  public categoryName: string = '';
  public categoryImage: string = '';
  public categoryBannerImage: string = '';
  public categoryTitle: string = '';
  public categoryContent: string = '';
  public categoryMeta: string = '{}';
  public codeSchema = '';
  public currentBottomText = '';
  public imageBase64Banner: string | ArrayBuffer;
  public selMenu = 'sub-category';
  public formMenu = 'main';

  @ViewChild('uploadPromoImage')
  uploadPromoImage: any;

  promoRedirectURL = '';

  //new feilds are below
  public questionOne = '';
  public answerOne = '';

  public questionTwo = '';
  public answerTwo = '';

  public questionThree = '';
  public anserThree = '';

  public questionFour = '';
  public anserFour = '';

  public questionFive = '';
  public anserFive = '';

  public selectedPromoFile: File | null = null;
  public encodedPromoFile: ArrayBuffer | string | null = null;

  public editCategorySubmit() {
    let formData = new FormData();
    typeof this.categoryImage == 'string'
      ? ''
      : formData.append('image', this.categoryImage);
    typeof this.categoryBannerImage == 'string'
      ? ''
      : formData.append('bannerImage', this.categoryBannerImage);

    formData.append('id', this.subCategory?.id);
    formData.append('name', this.categoryName.trim());
    // formData.append("title", this.categoryTitle)
    formData.append('promoFile', this.selectedPromoFile);
    formData.append('promoRedirectURL', this.promoRedirectURL);
    formData.append('content', this.categoryContent);

    //new feilds related to subcategory FAQ
    formData.append(
      'faqInfos',
      JSON.stringify({
        questionOne: this.questionOne,
        answerOne: this.answerOne,

        questionTwo: this.questionTwo,
        answerTwo: this.answerTwo,

        questionThree: this.questionThree,
        answerThree: this.anserThree,

        questionFour: this.questionFour,
        answerFour: this.anserFour,

        questionFive: this.questionFive,
        answerFive: this.anserFive,
      })
    );

    formData.append('metaConfig', this.categoryMeta);
    formData.append('codeSchema', this.codeSchema);
    formData.append('bottomText', this.currentBottomText);

    let subs;

    if (this.isSubregionCombination) {
      formData.append('subCategoryId', this.subCategory?.id);
      formData.append(
        'subRegionId',
        this.categoryEditMode ?? this.subRegionSlug
      );
      formData.append('typeId', this.currentType?.id ?? ''); //form data is only string??
      subs = this.auth.updateMetaInSubCategoryAndSubregionCombinationInfo(
        formData,
        '1'
      );
    } else {
      subs = this.auth.updateMemberCategoryInfo(formData);
    }
    subs.subscribe(
      (resp: ApiResponse) => {
        if (this.isSubregionCombination) {
          this._getCombinationInfos(this.categoryEditMode);
        }
        this.toastr.success(resp.message);
        // window.location.href = '/category/' + (this.subCategory?.slug) + (this.isSubregionCombination ? '/' + (this.currentSubRegionName).toLowerCase().split(' ').join('-') : '');
      },
      ({ error }) => {
        this.toastr.error(error.message);
      }
    );
  }

  public promoBannerChange(e) {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      this.selectedPromoFile = file;
      this.encodedPromoFile = reader.result;
    };
    reader.readAsDataURL(file);
  }

  public saveProductCharSelectedImage(event, isBanner = false) {
    this.subCategory
      ? (this.subCategory[isBanner ? 'bannerImage' : 'image'] = null)
      : '';
    let file = event.target.files[0];
    let fileReader = new FileReader();
    fileReader.onload = () => {
      if (!isBanner) {
        this.imageBase64 = fileReader.result;
        this.categoryImage = file;
      } else {
        this.imageBase64Banner = fileReader.result;
        this.categoryBannerImage = file;
      }
    };
    fileReader.readAsDataURL(file);
  }

  /*************************code related to types/faqs *********************************/
  public typesExist = true;
  public faqsExist = true;
  public showMap = true;

  public isInitDone = false;
  public carOptions = {
    slidesPerView: 1,
    //spaceBetween: 10,
    navigation: true,
    initialSlide: 0,
    autoHeight: false,
    nested: true,
    direction: 'horizontal',
    touchStartPreventDefault: false,
    touchStartForcePreventDefault: false,
  };
  public btnOptions = {
    slidesPerView: 1,
    //spaceBetween: 10,
    direction: 'vertical',
  };

  public setCurrentType(typeList) {
    // console.log("types set", { typeList })
    if (typeList.length == 0) {
      // console.log('getting products cause types are empty')
      this.currentPage = 1;
      this.totalMemberShopProductList = [];
      this.getProductList(); //here it's unsetting
      return;
    }
    this._setBreadCrumb();
    this.currentTypeName = typeList[0]?.name;
    this.currentPage = 2;
    this.totalMemberShopProductList = [];
    this.auth
      .fetchProductsBasedOnTypes({
        types: typeList.map((t) => t.id),
        areTypesNames: false,
        page: this.currentPage - 1,
        subregionName: this.currentSubRegionName,
        categoryId: this.currentCategoryId,
      })
      .subscribe({
        next: (data: any) => {
          this.isLoading = false;

          this.totalMemberShopProductList = [
            // ...this.totalMemberShopProductList,
            ...structuredClone(data?.data),
          ];

          this.productsToCompare = this.totalMemberShopProductList?.slice(0, 5);

          this.lastPage = data?.lastPage;
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.isLoading = false;
          console.error(err);
          this.cdr.detectChanges();
        },
      });
  }
  public realignSwiperIndexWhenTabsChange() {
    this.carOptions = { ...this.carOptions };
  }

  public isUserAnAdmin = false;

  /************************ Comapare products *****************************************/
  public turnComparisonOn() {
    this.isSelectProductsToCompareOn = true;
    this.toastr.info(
      'Select checkmarks on products then click compare product',
      'Comparing Products',
      { timeOut: 7000 }
    );
  }

  public isSelectProductsToCompareOn: boolean = false;

  public openCompareProductsModal() {
    //used to open a modal that is used to comapre the top 5 results from the search

    // this.productsToCompare.forEach(
    //   pd => {
    //     this.productBottomDiscussExperienceTabSettings.push(this.getBottomTabInfo(pd));
    //   }
    // )
    this.isSelectProductsToCompareOn = false;
    this.loadCompareProductsRatings();
    this.loadOtherImagesOfCompareProducts();
    this.productsToCompare.forEach((prod) => (prod.enableMemberShop = true));

    //console.log(this.productsToCompare)
    const ref = this.modalService.open(CompareProductListComponent, {
      size: 'lg',
      windowClass: 'transparent-window',
      modalDialogClass: 'glass-bg',
      centered: true,
    });
    ref.componentInstance.productsToCompare = this.productsToCompare;
    ref.componentInstance.productBottomDiscussExperienceTabSettings =
      this.productBottomDiscussExperienceTabSettings;
  }

  private loadCompareProductsRatings() {
    ////console.log('LOADING ratings') //DELETE LATTER
    for (const pd of this.productsToCompare) {
      this.loadRatingOn(pd);
    }
  }

  private loadMoreBadgesOfProduct(list) {
    if (list.otherRatingBadges?.length) {
      return;
    }
    list.otherRatingBadges = [];
    if (list && 'seller_info' in list) {
      try {
        let sellerInfo = list['seller_info'];
        if (typeof sellerInfo == 'string') {
          sellerInfo = JSON.parse(list['seller_info']);
        }

        if (sellerInfo) {
          if (
            'superDealRating' in sellerInfo &&
            (sellerInfo.superDealRating || sellerInfo.superDealText)
          ) {
            list.otherRatingBadges.push({
              icon: 'super_deal_1.png',
              name: 'Super Deal',
              rating: sellerInfo.superDealRating,
              text: sellerInfo.superDealText,
            });
          }

          if (
            'bestPriceRating' in sellerInfo &&
            (sellerInfo.bestPriceRating || sellerInfo.bestPriceText)
          ) {
            list.otherRatingBadges.push({
              icon: 'best_price_1.png',
              name: 'Best Price',
              rating: sellerInfo.bestPriceRating,
              text: sellerInfo.bestPriceText,
            });
          }

          if (
            'highQualityRating' in sellerInfo &&
            (sellerInfo.highQualityRating || sellerInfo.highQualityText)
          ) {
            list.otherRatingBadges.push({
              icon: 'high_quality_1.png',
              name: 'Hight Quality',
              rating: sellerInfo.highQualityRating,
              text: sellerInfo.highQualityText,
            });
          }
        }
      } catch (e) {
        console.warn(e);
      }
    }
  }
  productBottomDiscussExperienceTabSettings = [];

  private loadRatingOn(pd) {
    this.loadMoreBadgesOfProduct(pd);
    let ratings = [];

    if (pd && pd['seller_info']) {
      let sellerInfo = pd['seller_info'];
      ////console.log('seller_info is in productData', sellerInfo) //DELETE LATTER
      ////console.log('seller info is ', sellerInfo)

      if (sellerInfo && typeof sellerInfo === 'string') {
        sellerInfo = JSON.parse(sellerInfo);
      } else {
        pd.ratings = [];
      }
      if ('googleReviewRating' in sellerInfo) {
        ratings.push({
          icon: 'ggle.png',
          name: 'Google Reviews',
          ratingUrl: sellerInfo.googleReviewUrl,
          rating: sellerInfo.googleReviewRating,
          counts: sellerInfo.googleReviewCount,
        });
      }
      if ('fbReviewRating' in sellerInfo) {
        ratings.push({
          icon: 'facebook.png',
          name: 'Facebook Reviews',
          ratingUrl: sellerInfo.fbReviewUrl,
          rating: sellerInfo.fbReviewRating,
          counts: sellerInfo.fbReviewCount,
        });
      }

      if ('carousellReviewRating' in sellerInfo) {
        ratings.push({
          icon: 'carousell.png',
          name: 'Carousel Reviews',
          ratingUrl: sellerInfo.carousellReviewUrl,
          rating: sellerInfo.carousellReviewRating,
          counts: sellerInfo.carousellReviewCount,
        });
      }
    }
    ratings = structuredClone(ratings);
    //console.log('ratings are ', ratings)
    pd.ratings = ratings;
    this.cdr.detectChanges();
  }

  private getImageByAccessor(images, accessor) {
    const imageObj = images?.find((o) => o.imageAccessor === accessor);
    return imageObj ? imageObj.image : '';
  }

  private loadOtherImagesOfProduct(productData) {
    productData['foodSpecs'] = productData?.memberShopProductsVariations || [];
    productData['food_image_1'] = this.getImageByAccessor(
      productData.memberShopProductsImages,
      'image1'
    );
    productData['food_image_active'] = productData['food_image_1'];
    productData['food_image_2'] = this.getImageByAccessor(
      productData.memberShopProductsImages,
      'image2'
    );
    productData['food_image_3'] = this.getImageByAccessor(
      productData.memberShopProductsImages,
      'image3'
    );
    productData['food_image_4'] = this.getImageByAccessor(
      productData.memberShopProductsImages,
      'image4'
    );
  }
  private loadOtherImagesOfCompareProducts() {
    for (const prod of this.productsToCompare) {
      this.loadOtherImagesOfProduct(prod);
    }
  }
  /********************************************************************************** */

  /********************************************************************************** */

  public currentPage = 1;
  //region: Array<any>, filter: any
  private _getCombinationInfos(customSlug = null) {
    this.auth
      .getMetaInSubCategiryAndSubregionCombinationInfo(
        customSlug ? customSlug : this.subRegionSlug,
        this.subCategory?.id,
        '1',
        this.currentType?.id
      )
      .subscribe({
        next: (data) => {
          try {
            if (!data.body) {
              data.body = {};
            }

            this.subCategory.faqInfos = data.body?.faqInfos ?? '{}';

            this.categoryMeta = data.body?.categoryMeta ?? ''; //invalid json everytime!
            this.codeSchema = data.body?.codeSchema ?? '';
            this.bottomText = data.body?.bottomText ?? '';
            this.currentBottomText = this.bottomText;
            this.categoryImage = data.body?.categoryImage ?? '';
            this.cdr.detectChanges();
          } catch (e) {
            console.error(e);
            this.cdr.detectChanges();
          }
        },
        error: (err) => {
          console.error(err);
          this.cdr.detectChanges();
        },
      });
  }

  public domSchema: string = '';
  public domMeta: string = '';
  public get isOnTypeMode() {
    return !!this.currentTypeName;
  }
  public getProductList(subRegionId = [], reset = false) {
    if (this.isSubregionCombination) {
      // console.log('url is a combination')
      this._getCombinationInfos();
    }

    if (reset) {
      this.currentPage = 1;
    }

    this.isLoading = true;
    let payload = {
      basedProduct: 'all',
      page: this.currentPage++,
      categoryId: this.currentCategoryId as any,
      limit: 12,
      subregionName: this.currentSubRegionName,
      subRegionId,
    };

    this.customerService
      .getMemberShopProductList(payload)
      .subscribe((response: ApiResponse) => {
        //console.log({response})
        if (response?.body) {
          this.totalMemberShopProductList = [
            ...(reset ? [] : this.totalMemberShopProductList),
            ...structuredClone(response?.body.data),
          ];
          this.generateCategorySchema(this.subCategory);

          this.productsToCompare = this.totalMemberShopProductList?.slice(0, 5);

          this.lastPage = response?.body.lastPage;
          this.cdr.detectChanges();
        }
        this.isLoading = false;

        if (this.subCategory) {
          const images = new Map();
          const subCatKey = this.subCategory?.id;
          images.set(subCatKey, this.subCategory?.image);

          //this.googleMapsService.setCategoryIconMap(images);
          // console.log(images, this.subCategory)

          //no zoom when marker is clicked
          // this.googleMapsService.initMap(this.totalMemberShopProductList, 'map', false, false);
        } else {
          console.error('Category not loaded');
        }

        this.cdr.detectChanges();
      });
  }

  ////////////////////////////////////////////////////////recommendation///////////////////////////////
  public openRecommendationForm() {
    if (!this.local.getUser()) {
      this.commonService.clickButton('loginBtn');
      return;
    }
    if (this.sharedService.isOnMobile) {
      this.bottomSheet.open(RecommendationsFormComponent, {
        panelClass: 'bottom-sheet-1',
        hasBackdrop: true,
      });
    } else {
      this.modalService.open(RecommendationsFormComponent);
    }
  }

  public openReport() {
    this.local.alertReport().then((result) => {
      if (result.isConfirmed && result.value) {
        const report = result.value;

        const data = new FormData();
        data.append('message', report.reportDetails);
        data.append('type', report.reportType);
        data.append('category', 'member');
        data.append('image', report.file);
        this.auth.submitReportMessage(data).subscribe(
          () => {
            this.toastr.success('Reported successfully');
          },
          (e) => {
            this.toastr.error(e.error.message);
          }
        );
      }
    });
  }

  type = null;
  memberMessage = '';
  openSuggestModal(modal: any, type: any = '') {
    console.log('called!');
    this.memberMessage = '';
    this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'suggestion',
    });
    this.type = type;
  }
  public submitSuggestion() {
    if (!this.isLogin) {
      return this.toastr.error('Please Login First !');
    }
    let formData = new FormData();
    let message = this.memberMessage.trim();
    formData.append('message', message);
    // this.productData?.enableMemberShop
    //   ? formData.append('member_product_id', this.productData.id)
    //   : formData.append('product_id', this.productData.id);
    formData.append('type', this.type);

    if (message) {
      this.auth.submitSuggestionMessage(formData).subscribe((response: any) => {
        this.type = '';
        this.toastr.success(response.message);
        this.modalService.dismissAll();
      });
    } else {
      this.toastr.error('Suggestion is empty!');
    }
  }

  /////////////////////////////////////////////////////////////////////////////////////////////

  public bottomText = '';
  public getCategoryRelationship(categoryName, subCategoryName) {
    this.auth
      .getCategoryRelationshipByName({
        slug: categoryName.trim().toLowerCase(),
      })
      .subscribe((resp: ApiResponse) => {
        this.subCategory = resp?.body;
        this.subCategory?.relationCategories?.sort((a, b) =>
          a?.name?.localeCompare(b?.name)
        );

        this.isInitDone = true;
        this.currentCategoryName = this.subCategory.name;
        this.currentCategoryBG = this.subCategory.bannerImage;
        if (!this.currentCategoryBG) {
          // console.log('current category is null', this.subCategory);

          this.currentCategoryBG =
            this.subCategory?.parentCategory?.bannerImage;
        }
        this.parentCategory = this.subCategory.parentCategory;

        if (this.isSubregionCombination) {
          this._getCombinationInfos();
        }

        // if(this.sharedService.isBrowser() && this.subCategory?.codeSchema){
        //   try{
        //       //making sure error here doesn't crash the view
        //       eval(this.subCategory?.codeSchema)
        //   }catch(e){
        //     console.error(e);

        //   }
        // }
        this.bottomText = this.subCategory?.bottomText;
        console.log(this.bottomText, 'BOTTOM TEXT');

        if (this.subCategory?.name) {
          let description = this.bottomText;
          if (
            description == 'undefined' ||
            description == null ||
            description == ''
          ) {
            description = `Find the best ${this.subCategory?.name} services in Singapore. Browse our curated list of ${this.subCategory?.name} service providers, read reviews, and book appointments easily.`;
            if (this.currentSubRegionName) {
              description = `Find the best ${this.subCategory?.name} services in ${this.currentSubRegionName}, Singapore. Browse our curated list of ${this.subCategory?.name} service providers, read reviews, and book appointments easily.`;
            }
          }

          let title = this.subCategory?.name;
          if (this.currentSubRegionName) {
            title = `${this.subCategory?.name} in ${this.currentSubRegionName}`;
          }

          this.seoService.update({
            title: title,
            description: description,
            main_title: ' | BEST SERVICES SG',
          });
        }
        this.generateCategorySchema(this.subCategory);
        this._setBreadCrumb();
        this.subCategoryList = resp?.body?.subCategory || [];

        this.subCategoryList?.sort((a, b) =>
          a?.categoryName?.localeCompare(b?.categoryName)
        );

        if (this.subCategoryList.length > 0 && subCategoryName) {
          this.currentCategoryId = this.subCategoryList.find(
            (i) => i.categoryName.toLowerCase() == subCategoryName.toLowerCase()
          )?.categorieChildId;
          this.getProductList();
        } else if (this.subCategoryList.length > 0) {
          this.currentCategoryId = this.subCategoryList.map(
            (i) => i.categorieChildId
          );
          this.getProductList();
        } else {
          this.currentCategoryId = [resp?.body?.id];
          this.getProductList();
        }

        if (this.sharedService.isBrowser()) {
          this.seoService.removeSchema();
          this.seoService.initCategorySchema(this.subCategory);
        }
        this.cdr.detectChanges();
      });
  }

  public currentCategoryId;
  public goBack() {
    this.commonService.goBack();
  }

  public viewProductDetails(product): void {
    this.marketplacePage.enableMemberShop = true;
    this.marketplacePage.viewProduct(product);
  }

  public searchProds = [];
  @ViewChild('seeProductList')
  public seeProductList: TemplateRef<any>;

  public goToProduct(prod) {
    window.open('product/' + prod.slug, '_blank');
  }

  public searchSimilarSubType(subType) {
    this.totalMemberShopProductList = [];
    this.currentPage = 1;

    this.auth
      .fetchProductsBasedOnTypes({
        types: [subType.id],
        isSubType: true,
        page: this.currentPage,
      })
      .subscribe({
        next: (data: any) => {
          this.isLoading = false;

          this.totalMemberShopProductList = [
            ...this.totalMemberShopProductList,
            ...structuredClone(data?.data),
          ];
          this.generateCategorySchema(this.subCategory);

          this.productsToCompare = this.totalMemberShopProductList?.slice(0, 5);

          this.lastPage = data?.lastPage;
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.isLoading = false;
          console.error(err);
          this.cdr.detectChanges();
        },
      });
  }

  public generateCategorySchema(category: any) {
    const validSchemaTypes = [
      'HealthAndBeautyBusiness',
      'LocalBusiness',
      'Store',
      'Restaurant',
      'FoodEstablishment',
      'Service',
    ];

    const categoryBeauty = [
      'Beauty',
      'Skin',
      'Body',
      'Hair',
      'Men',
      'Eyebrows',
      'Manicure',
      'Lashes',
    ];

    const schemas = this.totalMemberShopProductList.map((product) => {
      // Check each word in category name against valid schema types
      let schemaType = 'Service'; // Default to Service
      const categoryWords = category.name.split(/\s+/);

      // First check if any word matches categoryBeauty
      for (const word of categoryWords) {
        if (categoryBeauty.includes(word)) {
          schemaType = 'HealthAndBeautyBusiness';
          break;
        }
      }

      // If no beauty match found, check other valid schema types
      if (schemaType === 'Service') {
        for (const word of categoryWords) {
          const matchedType = validSchemaTypes.find(
            (type) =>
              type.toLowerCase().includes(word.toLowerCase()) ||
              word.toLowerCase().includes(type.toLowerCase())
          );
          if (matchedType) {
            schemaType = matchedType;
            break;
          }
        }
      }
      const baseSchema = {
        '@context': 'https://schema.org',
        '@type': schemaType,
        url: `https://kachiing.com/product/${product.slug}`,
        name: product.name,
        image: this.imgUrl + product.primaryImage,
        priceRange: `From SGD ${
          product.memberShopProductsVariations[0]?.key || 0
        }`,
        address: {
          '@type': 'PostalAddress',
          streetAddress: `${product.address || ''}, ${
            this.currentSubRegionName || 'Singapore'
          }`,
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: this.postalCode?.lat || 1.3521,
          longitude: this.postalCode?.lng || 103.8198,
        },
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: product.rating || 5,
          ratingCount: product.reviewCount || 0,
          worstRating: 1,
          bestRating: 5,
        },
      };

      if (schemaType === 'Service') {
        const { address, geo, priceRange, ...serviceSchema } = baseSchema;
        return {
          ...serviceSchema,
          serviceType: product.name,
          provider: {
            '@type': 'LocalBusiness',
            name: product.brandName || 'Kachiing',
          },
          offers: {
            '@type': 'Offer',
            price: product.memberShopProductsVariations[0]?.key || 0,
            priceCurrency: 'SGD',
          },
        };
      } else if (schemaType === 'HealthAndBeautyBusiness') {
        return {
          ...baseSchema,
          makesOffer: {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: product.name,
              description: this.local.removeHtmlTagsAndGetTextContent(
                product.description
              ),
            },
          },
          telephone: product.phone || '',
          openingHoursSpecification: product.openingHours || [],
          areaServed: {
            '@type': 'City',
            name: 'Singapore',
          },
        };
      } else {
        return baseSchema;
      }
    });

    if (this.sharedService.isBrowser()) {
      this.seoService.updateSchema('custom', JSON.stringify(schemas));
    }

    // Add product schema
    const productSchema = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: `Best ${this.currentCategoryName} in ${
        this.currentSubRegionName || 'Singapore'
      }`,
      description: `Find and compare the best ${
        this.currentCategoryName
      } services in ${this.currentSubRegionName || 'Singapore'} with Kachiing.`,
      aggregateRating: {
        '@type': 'AggregateRating',
        bestRating: 5,
        worstRating: 1,
        ratingValue: 4,
        reviewCount: this.totalMemberShopProductList?.length || 0,
      },
      brand: {
        '@type': 'Organization',
        '@id': 'https://kachiing.com/',
        name: 'BEST SERVICES SG',
        sameAs: ['https://www.instagram.com/kachiingsg'],
        url: 'https://kachiing.com/',
        contactPoint: {
          '@type': 'ContactPoint',
          areaServed: 'SG',
          contactType: 'customer service',
        },
      },
    };

    if (this.sharedService.isBrowser()) {
      this.seoService.updateSchema('custom', JSON.stringify(productSchema));
    }

    return schemas;
  }
}
